import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import ShowContainer from "../ShowContainer";
import { Autoplay, Pagination, Navigation } from "swiper/modules"; // 🧠 импорт модуля

/**
 *
 * @param {import("swiper/react").SwiperProps} props
 */
export default function CustomCarousel({ children, ...props }) {
  return (
    <ShowContainer condition={React.Children.count(children)}>
      <div className="custom__carousel">
        <Swiper {...props} modules={[Autoplay, Pagination, Navigation]} onSwiper={props.onSwiper}>
          {React.Children.map(children, (child, index) => (
            <SwiperSlide key={index} className="carousel-item">
              {child}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </ShowContainer>
  );
}
